import { APP_THEME_MAP } from '@/common/constants/themes.constants';
import virtuozzoColorScheme from '@/hci/config/virtuozzoColorScheme';

type ColorScheme = Record<string, string>;
type ThemeName = keyof typeof APP_THEME_MAP;

export const applyCssVariables = (scheme: ColorScheme): void => {
  Object.entries(scheme).forEach(([property, value]) => {
    document.documentElement.style.setProperty(property, value);
  });
};

const replacedColors = {
  [APP_THEME_MAP.virtuozzo]: {
    '--av-brand-secondary': virtuozzoColorScheme['--av-brand-secondary'],
  },
  [APP_THEME_MAP.acronis]: {}
};

export const applyColorScheme = (colorScheme: ColorScheme): void => {
  const mergedScheme = {
    ...colorScheme,
    ...replacedColors[APP_THEME],
  };
  applyCssVariables(mergedScheme);
};

export default function applyColors(theme: ThemeName = APP_THEME): void {
  if (typeof window === 'undefined') {
    return;
  }

  const VIRTUOZZO_THEME_CLASS = 'virtuozzo-theme';

  if (theme === APP_THEME_MAP.virtuozzo) {
    document.documentElement.className = VIRTUOZZO_THEME_CLASS;
    applyCssVariables(virtuozzoColorScheme);
  } else {
    document.documentElement.classList.remove(VIRTUOZZO_THEME_CLASS);
    document.documentElement.style.cssText = '';
  }
}
